<template>
  <div class="content-section" v-loading.fullscreen.lock="fullscreenLoading">
    <h2 class="page-title">法律文书</h2>
    <div >
      <el-form :inline="true" :model="queryParams" class="demo-form-inline">
        <!--<el-form-item label="案件ID">-->
          <!--<el-input disabled v-model="queryParams.keyValue"></el-input>-->
        <!--</el-form-item>-->
        <el-form-item label="关键字">
          <el-input v-model="queryParams.keyWord" placeholder="关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table
        :data="lawsData"
        height="500"
        v-loading="tableLoading"
        border
        style="width: 100%">

        <el-table-column
          prop="F_CaseId"
          label="案件编号"
          align="center"
          header-align="center"
        >
        </el-table-column>
        <el-table-column
          prop="F_CompanyName"
          align="center"
          header-align="center"

          label="企业名称">
        </el-table-column>
        <el-table-column
          prop="F_ProjectName"
          align="center"
          header-align="center"

          label="项目名称">
        </el-table-column>
        <el-table-column
          prop="F_FileName"
          align="center"
          header-align="center"
          label="附件名称">
          <template slot-scope="scope">
            <el-link @click="open1(scope.row)" type="primary" target="_blank">{{scope.row.F_FileName}}</el-link>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          header-align="center"
          width="100"
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-link @click="toLaw(scope.row)" type="primary" target="_blank">上传</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="PageSize"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog center width="500px" title="上传法律文书" :visible.sync="dialogFJVisibleLaw" :close-on-click-modal="false">
      <el-form  :model="lawForm" label-width="100px">
        <el-form-item label="下载附件:">
          <el-link :href="lawData.F_FilePath" type="primary" target="_blank">{{lawData.F_FileName}}</el-link>
        </el-form-item>
        <el-form-item v-if="lawData.F_IsAllowCustomLoad" label="上传附件:">
          <el-upload :limit="limitLaw" :headers="uploadHeaders" :data="extraParamsLaw" :action="uploadUrl" :class="{ 'hide': hideUpload }"
                     :with-credentials="true" list-type="text" :file-list="fileListLaw" :on-success="handleSuccessLaw" :before-upload="beforeUploadLaw"
                     :on-remove="handleRemoveLaw">
            <span style="color: #409EFF;">选择法律文书</span>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" plain @click="saveLaw">保 存</el-button>
        <el-button type="info" plain @click="dialogFJVisibleLaw = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {

      return {
        queryParams:{
          keyValue:'',
          keyWord:''
        },

        url: {
          list: SZH.assets.api + '/Custom/GetPagingCaseFLWS',
          GetCustomCaseFLWS: SZH.assets.api + '/Custom/GetCustomCaseFLWS',//人脸检测
          SaveFile: SZH.assets.api + '/Custom/SaveFile',//人脸检测
        },
        tableLoading:false,
        dialogFJVisibleLaw:false,
        loadingFull:false,
        fullscreenLoading:false,
        PageIndex:1,
        PageSize:50,
        total:0,
        lawsData:[],
        limitLaw:1,
        fileListLaw:[],
        countLaw:0,
        hideUpload: false,
        lawForm:{
          F_FilePath:'',
          F_Id:''
        },
        caseId:'',
        lawData:{
          F_FileName:'',
          F_FilePath:'',
          F_IsAllowCustomLoad:null
        },
        obj:{}
      }
    },
    methods: {
      search(){
        this.lawsData = [];
        this.PageIndex = 1;
        this.loadData();
      },
      open1(row){
        window.open(SZH.assets.image +'/' + row.F_FilePath);
      },
      beforeUploadLaw(file){
        const self = this;
        if(self.fileListLaw && self.fileListLaw.length>0){
          self.$message.error('文件只能上传一次！');
          return
        }
        const isPDF = file.type === 'application/pdf';
        const isLt2M = file.size / 1024 / 1024 < 100;
        if (!isPDF) {
          self.$message.error('上传的文件只能是PDF格式!');
        }else if (!isLt2M) {
          self.$message.error('上传的文件大小不能超过 100MB!');
        }

        return isLt2M && isPDF;
      },
      handleSuccessLaw(response, file, fileList) {
        if (response && response[0].success == true) {
          this.countLaw = fileList.length;
          this.fileListLaw = [];
          this.lawForm.F_FilePath = response[0].FileName;
          let obj = {
            name:'',
            url:''
          };
          obj.name = response[0].File;
          obj.url = response[0].FileName;
          this.fileListLaw.push(obj);
        }else{
          this.$message.error(response[0].message)
        }
      },
      handleRemoveLaw(file, fileList) {
        var self = this;
        self.countLaw = fileList.length;
        self.lawForm.F_FilePath = '';
        self.fileListLaw = [];
      },
      toLaw(row){
        let self = this;
        self.obj = row;
        self.lawForm.F_FilePath = '';
        self.fileListLaw = [];
        self.dialogFJVisibleLaw = true;
        self.fullscreenLoading = true;
        self.$http.post(self.url.GetCustomCaseFLWS,{
          keyValue:row.F_Id
        })
          .then(result => {
            if (result.state == true) {
              self.lawForm.F_Id = result.data.F_Id;
              self.lawData.F_FileName = result.data.F_FileName;
              self.lawData.F_FilePath = SZH.assets.image+'/' + result.data.F_FilePath;
              self.lawData.F_IsAllowCustomLoad = result.data.F_IsAllowCustomLoad;
              self.fullscreenLoading = false;
            } else {
              self.lawForm.F_Id = '';
              self.lawData.F_FileName = '';
              self.lawData.F_FilePath = '';
              self.lawData.F_IsAllowCustomLoad = null;
              self.fullscreenLoading = false;
              self.$message.error(result.message);
            }
          }, () => {
            self.fullscreenLoading = false;
            // 请求失败
            self.$message.error('失败，请检查您的网络是否可用。');
          });
      },
      saveLaw(){
        let self = this;
        if(!self.lawForm.F_FilePath){
          self.$message.error('请上传法律文书!');
          return
        }
        self.fullscreenLoading = true;
        self.$http.post(self.url.SaveFile,self.lawForm)
          .then(result => {
            if (result.state == true) {
              self.dialogFJVisibleLaw = false;
              self.loadData();
              self.fullscreenLoading = false;
            } else {
              self.fullscreenLoading = false;
              self.$message.error(result.message);
            }
          }, () => {
            self.fullscreenLoading = false;
            // 请求失败
            self.$message.error('失败，请检查您的网络是否可用。');
          });
      },
      onSizeChange(val) {
        this.PageSize = val;
        this.loadData();
      },
      onCurrentChange(val) {
        this.PageIndex = val;
        this.loadData();
      },

      loadData(){
        let self = this;
        self.tableLoading = true;
        self.$http.post(self.url.list,{
          Data:self.queryParams,
          PageIndex:self.PageIndex,
          PageSize:self.PageSize
        })
          .then(result => {
            if (result.state == true && result.data && result.data.Data && result.data.Data.length>0) {
              self.lawsData = result.data.Data;
              self.total = result.data.TotalCount;
              self.tableLoading = false;
            } else {
              self.lawsData = [];
              self.total = 0;
              self.tableLoading = false;
              self.$message.error(result.message);
            }

          }, () => {
            self.tableLoading = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
    },
    computed: {
      uploadHeaders() {
        var token = localStorage.ms_token;
        return {Authorization: 'Bearer ' + token};
      },
      extraParamsLaw(){
        return {
          upLoadType:'2',
          upLoadFolder:'',
          ImageType:'CaseFLWS',
          code:''
        }
      },
      uploadUrl() {
        return SZH.assets.api + '/File/PostFile'
      },
    },
    components: {
    },
    mounted() {
      this.caseId = this.$route.query.id;
      this.queryParams.keyValue = this.$route.query.id;
      this.loadData()
    }
  }
</script>

<style scoped>
  .subaccount-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Me/LawList/LawList.vue